import React, { Component } from "react";
import {
  ModalHeader,
  ModalBody,
  } from "reactstrap";
import QrReader from "react-qr-reader";

export default class QRCodeScanner extends Component {
    constructor(props) {
      super(props);
      this.handleScan = this.handleScan.bind(this);
    }
    handleScan(data) {
        if (data) {
          this.props.onResult(data)
          this.props.goBack()
        }
      }
    handleError(err) {
      console.error(err);
      alert("Something went wrong.");
    }
    
    render() {
        return (
          <div>
            <ModalHeader toggle={this.props.goBack}></ModalHeader>
            <ModalBody>
              <QrReader
              onError={this.handleError}
              onScan={this.handleScan}
              style={{ width: "100%",height:'50%' }}
              />
            </ModalBody>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/QRCodeScanner/QRCodeScanner.js